export const isMobileDevice = () => {
  return (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPad/i)
  );
};

export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
